<app-header></app-header>
<app-banner></app-banner>
<router-outlet></router-outlet>
<app-contacts-footer></app-contacts-footer>
